import React, { useState } from "react";

// Shared numeric input — type="text" + inputMode="decimal", live comma
// formatting while editing, select-all on focus, parseFloat commit on blur.
// Extracted verbatim from the AdminPage inline pattern (AdminPage.js:216) for
// reuse by the cat-1 Forecast Wizard. Existing pages keep their own inline
// copies — this is ADDITIVE, no rewiring (consolidation tracked in §12).
// showZero (default false): when true, a value of 0 renders as the formatted "0"
// instead of blank — so a deliberately-SAVED $0 reads as set, not empty. Default
// false preserves the original behavior (0 → blank) for every other caller.
export default function NumInput({ value, onChange, decimals = 2, style, placeholder, disabled, showZero = false }) {
  const [ed, setEd] = useState(false);
  const [raw, setRaw] = useState('');
  const n = Number(value) || 0;
  const display = (n || showZero)
    ? n.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
    : '';
  const fmtLive = (v) => {
    const stripped = String(v).replace(/[^0-9.]/g, '');
    if (!stripped) return '';
    const firstDot = stripped.indexOf('.');
    const cleaned = firstDot === -1
      ? stripped
      : stripped.slice(0, firstDot + 1) + stripped.slice(firstDot + 1).replace(/\./g, '');
    const parts = cleaned.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (parts.length > 1) return parts[0] + '.' + parts[1].slice(0, Math.max(decimals, 2));
    return parts[0];
  };
  return (
    <input type="text" inputMode="decimal" style={style} placeholder={placeholder || ''} disabled={disabled}
      value={ed ? fmtLive(raw) : display}
      onFocus={(e) => { setEd(true); setRaw(n ? String(n) : (showZero ? '0' : '')); setTimeout(() => e.target.select(), 0); }}
      onChange={(e) => { setRaw(e.target.value.replace(/,/g, '')); }}
      onBlur={() => {
        setEd(false);
        const cleaned = String(raw).replace(/[^0-9.]/g, '');
        const parsed = parseFloat(cleaned);
        onChange(isNaN(parsed) ? 0 : parsed);
      }} />
  );
}
